module.exports = __webpack_public_path__ + "static/media/closeFilter.00392365.svg";